<template>
  <span class="ticket-table-badges">
    <app-status-badge
      v-for="item in visibleItems"
      :key="item.id"
      design="new"
      compact
      :label="item.name"
      :color="item.color"
    />
    <span
      v-if="hiddenItems.length"
      v-tooltip="tooltip"
      :tabindex="keyboardTooltips ? 0 : null"
      :class="{ 'ui-tooltip-target': keyboardTooltips }"
      class="ticket-table-badges__more"
    >
      +{{ hiddenItems.length }}
    </span>
    <span v-if="!items.length" class="ticket-table-badges__empty">—</span>
  </span>
</template>

<script>
export default {
  name: 'SupportTicketTableBadges',
  props: {
    items: { type: Array, default: () => [] },
    limit: { type: Number, default: 2 },
    keyboardTooltips: Boolean
  },
  computed: {
    visibleItems() { return this.items.slice(0, this.limit) },
    hiddenItems() { return this.items.slice(this.limit) },
    tooltip() {
      return {
        content: this.hiddenItems.map(item => item.name).join(', '),
        placement: 'top',
        offset: 8,
        classes: 'tooltip--new'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket-table-badges { display: flex; min-width: 0; align-items: center; gap: 4px; overflow: hidden; }
.ticket-table-badges__more { display: inline-flex; min-height: 24px; align-items: center; padding: 2px 7px; border: 1px solid $ui-line; border-radius: $ui-control-radius; color: $ui-muted; font-weight: 700; }
.ticket-table-badges__empty { color: $ui-muted; }
</style>
